module.exports = __webpack_public_path__ + "static/media/calendar-day.134588e8.svg";